var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "content"
  }, [_vm.$store.state.utils.configuration.enableNewProductMissingModal ? _c('div', [_c('div', {
    staticClass: "new-modal-error-icon"
  }, [_vm._v("!")]), _c('h2', {
    staticClass: "new-modal-title"
  }, [_vm._v(_vm._s(_vm.translations.productMissing404))]), _c('p', {
    staticClass: "new-modal-description"
  }, [_vm._v("\n      " + _vm._s(_vm.translations.productMissingText) + "\n    ")])]) : _c('h5', {
    staticClass: "text-center subheader"
  }, [_vm._v("\n    " + _vm._s(_vm.translations.productMissingDesc) + "\n  ")])]);
}
var staticRenderFns = []

export { render, staticRenderFns }